const MESSAGES = {
  ar: {
    invalidMonthEnd: "التاريخ المحدد غير صالح لهذا التقرير. يجب اختيار آخر يوم في الشهر.",
    badRequest: "تعذر تنفيذ التقرير لأن بعض بيانات الفلترة غير صحيحة.",
    unauthorized: "غير مصرح لك بالوصول إلى هذا التقرير.",
    forbidden: "لا تملك صلاحية كافية لعرض هذا التقرير.",
    notFound: "لم يتم العثور على بيانات للتقرير المطلوب.",
    rateLimit: "تم تجاوز الحد المسموح من الطلبات. حاول مرة أخرى بعد قليل.",
    serverError: "حدث خطأ في خادم التقارير. حاول مرة أخرى بعد قليل.",
    unknown: "تعذر جلب بيانات التقرير في الوقت الحالي.",
  },
  en: {
    invalidMonthEnd: "This report requires the date to be the last day of the month.",
    badRequest: "The report request could not be completed because some filters are invalid.",
    unauthorized: "You are not authorized to access this report.",
    forbidden: "You do not have permission to view this report.",
    notFound: "No data was found for the requested report.",
    rateLimit: "Too many requests were sent. Please try again shortly.",
    serverError: "A report server error occurred. Please try again later.",
    unknown: "The report data could not be fetched right now.",
  },
};

const getLocale = (language) => (language === "Arabic" || language === "ar" ? "ar" : "en");

const firstString = (value) =>
  Array.isArray(value)
    ? value.find((item) => typeof item === "string" && item.trim())
    : typeof value === "string" && value.trim()
    ? value
    : "";

const extractApiDetail = (data) => {
  if (!data || typeof data !== "object") {
    return "";
  }

  if (Array.isArray(data.errors) && data.errors.length > 0) {
    const detail = data.errors.find((item) => typeof item?.detail === "string" && item.detail.trim());
    if (detail?.detail) {
      return detail.detail;
    }
  }

  return (
    firstString(data.detail) ||
    firstString(data.error) ||
    firstString(data.message) ||
    firstString(data.non_field_errors)
  );
};

// getBalanceSheet rewraps axios errors as plain Error(message), losing name/code —
// so cancellation must also be detected by axios's literal "canceled" message.
export const isRequestCancelled = (error) =>
  error?.name === "CanceledError" ||
  error?.name === "AbortError" ||
  error?.code === "ERR_CANCELED" ||
  error?.message === "canceled";

export const formatReportApiError = (error, language = "ar") => {
  const locale = getLocale(language);
  const messages = MESSAGES[locale];
  const status = error?.response?.status;
  const detail = extractApiDetail(error?.response?.data);
  const rawMessage = detail || error?.message || "";

  if (/last day of the month/i.test(rawMessage)) {
    return messages.invalidMonthEnd;
  }

  if (detail) {
    return detail;
  }

  if (status === 400 || status === 422) {
    return messages.badRequest;
  }

  if (status === 401) {
    return messages.unauthorized;
  }

  if (status === 403) {
    return messages.forbidden;
  }

  if (status === 404) {
    return messages.notFound;
  }

  if (status === 429) {
    return messages.rateLimit;
  }

  if (status >= 500) {
    return messages.serverError;
  }

  return messages.unknown;
};
